import React, { useState, useRef } from 'react';
import {
  stage as stageEnum,
  getPublicFolderPath,
  getStagePosition,
  stageInTimeline,
} from '../../../../utils';
import { ILine } from '../../../../global';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  image: {
    position: 'absolute',
    cursor: 'default',
    transform: 'translateX(-50%)',
  },
  imageBackground: {
    backgroundColor: theme.palette.brand.greyDark,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: '100%',
  },
  menu: {
    cursor: 'default',
    '& .MuiList-root': {
      width: 120,
    },
    '& .MuiList-padding': { padding: theme.spacing(1) },
  },
  name: { fontWeight: 'bold' },
}));

function getStage(line: ILine, stageName: string) {
  const stage = line.stages.find((stage) => stage.name === stageName);
  return stage;
}

function doStagesOverlap(line: ILine, stageName: string) {
  const stage = line.stages.find((stage) => stage.name === stageName);
  const sellingStart = line.stages.find(
    (stage) => stage.name === stageEnum.sellingStart.value,
  );
  const diff = moment(stage?.start).diff(moment(sellingStart?.start), 'days');
  const stagesOverlap = Math.abs(diff) <= 7;
  return stagesOverlap;
}

export default function CompleteOrRepay({ line, stageName, timelineInfo }) {
  const classes = useStyles();
  const ref = useRef();
  const stage = getStage(line, stageName);
  const getPosition = getStagePosition(line, stage);
  const [open, setOpen] = useState(false);

  const displayName = stageEnum[stageName]?.label;
  const stagesOverlap = doStagesOverlap(line, stageName);
  const extraStyling = {};
  if (stagesOverlap) {
    extraStyling['top'] = -16;
  }

  const showStage = stageInTimeline(stage, timelineInfo);

  function openStageDetails() {
    !open && setOpen(true);
  }

  function closeStageDetails() {
    open && setOpen(false);
  }

  return (
    <>
      {stage && showStage && (
        <>
          <div
            className={classes.image}
            style={{
              left: `${getPosition}%`,
              ...extraStyling,
            }}
          >
            <div
              className={classes.imageBackground}
              onMouseOver={openStageDetails}
            >
              <img
                src={
                  getPublicFolderPath(window.location.pathname) +
                  stageEnum[stageName]?.image
                }
                alt="Icon"
                ref={ref}
              />
            </div>
          </div>
          <Menu
            open={open}
            onClose={closeStageDetails}
            keepMounted
            anchorEl={ref.current}
            className={classes.menu}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            disableRestoreFocus
          >
            <div onMouseLeave={closeStageDetails}>
              <Typography variant="subtitle1" className={classes.name}>
                {displayName}
              </Typography>
              <Typography variant="subtitle1">
                {moment(stage.start).format('MMM DD')}
              </Typography>
            </div>
          </Menu>
        </>
      )}
    </>
  );
}
